import axios from 'axios';

import APIService from '_app/services/api';

export const fetchProfile = async () => {
  const { data } = await APIService.get('/profile/');
  return data;
};

export const submitMarketingConsent = async ({ phone, marketing_consent, publicId }) => {
  const formData = new FormData();
  formData.append('phone', phone);
  formData.append('marketing_consent', marketing_consent);

  const { data } = await axios.post(`https://my.houstonproperties.com/home-valuation/${publicId}/activity/marketing-consent/`, formData);
  return data;
};
